import { createSlice } from '@reduxjs/toolkit';
import { logout } from '../auth';
import discussionApi from '../../api/discussionApi';

const initialState = {
  discussion: undefined,
  fieldUpdate: undefined,
  updateSocket: undefined,
  unitDiscussion: undefined,
  checkUpdateStatus: 0,
  error: undefined,
};

const discussionSlice = createSlice({
  name: 'discussion',
  initialState,
  reducers: {
    setDiscussion: (state, action) => {
      state.discussion = action.payload;
    },
    setDiscussionError: (state, action) => {
      state.error = action.payload;
    },
    setFieldUpdate: (state, action) => {
      state.fieldUpdate = action.payload;
    },
    setUpdateSocket: (state, action) => {
      state.updateSocket = action.payload;
    },
    setUnitDiscussion: (state, action) => {
      state.unitDiscussion = action.payload;
    },
    setCheckUpdateStatus: (state, action) => {
      state.checkUpdateStatus = action.payload;
    },
  },
  extraReducers: {
    [logout]: (state) => initialState,
  },
});

export const getDiscussion = (state) => state.discussion.discussion;
export const getDiscussionError = (state) => state.discussion.error;
export const getFieldUpdate = (state) => state.discussion.fieldUpdate;
export const getUpdateSocket = (state) => state.discussion.updateSocket;
export const getUnitDiscussion = (state) => state.discussion.unitDiscussion;
export const getCheckUpdateStatus = (state) =>
  state.discussion.checkUpdateStatus;

export const {
  setDiscussion,
  setFieldUpdate,
  setUpdateSocket,
  setUnitDiscussion,
  setDiscussionError,
  setCheckUpdateStatus,
} = discussionSlice.actions;

export const getDiscussionAsync = (params) => async (dispatch) => {
  const response = await discussionApi.getById(params);
  return dispatch(setDiscussion(response));
};

export default discussionSlice.reducer;
